var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGeneral(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.771,
    height: 19.771,
    viewBox: "0 0 19.771 19.771",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6360",
    "data-name": "Group 6360",
    transform: "translate(-608 -250)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7156",
    "data-name": "Path 7156",
    d: "M21.55,6.221V19.55a2.221,2.221,0,0,1-2.221,2.221H8.221A2.221,2.221,0,0,1,6,19.55V6.221A2.221,2.221,0,0,1,8.221,4H19.329A2.221,2.221,0,0,1,21.55,6.221Z",
    transform: "translate(605.221 247)",
    fill: "none",
    stroke: "#758ca1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7157",
    "data-name": "Path 7157",
    d: "M10,16h6.664",
    transform: "translate(605.664 248.329)",
    fill: "none",
    stroke: "#758ca1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7158",
    "data-name": "Path 7158",
    d: "M13.221,11.221m-2.221,0A2.221,2.221,0,1,0,13.221,9,2.221,2.221,0,0,0,11,11.221",
    transform: "translate(605.775 247.554)",
    fill: "none",
    stroke: "#758ca1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7159",
    "data-name": "Path 7159",
    d: "M4,8H7.332",
    transform: "translate(605 247.443)",
    fill: "none",
    stroke: "#758ca1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7160",
    "data-name": "Path 7160",
    d: "M4,12H7.332",
    transform: "translate(605 247.886)",
    fill: "none",
    stroke: "#758ca1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7161",
    "data-name": "Path 7161",
    d: "M4,16H7.332",
    transform: "translate(605 248.329)",
    fill: "none",
    stroke: "#758ca1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneral);
export default __webpack_public_path__ + "static/media/general.956eea85.svg";
export { ForwardRef as ReactComponent };